import React, { useState } from 'react';

const field = { padding: 10, borderRadius: 10, border: '1px solid #334155', background: '#0A192F', color: '#fff', fontSize: '0.95rem', width: '100%', boxSizing: 'border-box' };

/**
 * Lien fermé (plus d'une heure après la fin de la session) : message de
 * confidentialité, et demande d'accès réservée aux personnes en charge d'une
 * enquête. La demande part par e-mail à l'équipe MonAlerte, qui recontacte.
 */
export default function ExpiredSessionNotice({
    sessionId, apiUrl, requestPath = null, title = 'Cette session n’est plus disponible', intro = null, children = null,
}) {
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({ organization: '', reference: '', name: '', email: '', phone: '', reason: '' });
    const [state, setState] = useState({ sending: false, done: '', error: '' });
    const set = key => event => setForm(previous => ({ ...previous, [key]: event.target.value }));

    const submit = async event => {
        event.preventDefault();
        setState({ sending: true, done: '', error: '' });
        try {
            const body = Object.fromEntries(Object.entries(form).map(([key, value]) => [key, value.trim()]).filter(([key, value]) => key !== 'reference' || value));
            const response = await fetch(`${apiUrl.replace(/\/+$/, '')}${requestPath || `/api/session/${encodeURIComponent(sessionId)}/investigation-request`}`, {
                method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body),
            });
            const payload = await response.json().catch(() => ({}));
            if (!response.ok) throw new Error(payload.message || 'Envoi impossible.');
            setState({ sending: false, done: payload.message || 'Demande transmise.', error: '' });
        } catch (error) {
            setState({ sending: false, done: '', error: error.message });
        }
    };

    return (
        <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 24, background: '#0A192F', color: '#E0E0E0' }}>
            <section style={{ width: '100%', maxWidth: 560, background: '#112240', borderRadius: 16, padding: 28, display: 'grid', gap: 14 }}>
                <div style={{ fontSize: '2rem' }} aria-hidden>🔒</div>
                <h1 style={{ margin: 0, fontSize: '1.35rem' }}>{title}</h1>
                {intro || (
                    <p style={{ margin: 0, color: '#A0A0A0', lineHeight: 1.5 }}>
                        Pour des raisons de confidentialité, une session n’est accessible par son lien que pendant son déroulement
                        et une heure après sa fin. Seules les personnes en charge d’une enquête peuvent en demander l’accès :
                        après vérification, l’équipe MonAlerte les recontacte pour leur transmettre les informations nécessaires.
                    </p>
                )}
                {children}
                {state.done ? (
                    <p role="status" style={{ margin: 0, color: '#86efac' }}>{state.done}</p>
                ) : !open ? (
                    <button type="button" onClick={() => setOpen(true)}
                        style={{ padding: 12, borderRadius: 10, border: 0, background: '#FACC15', color: '#0A192F', fontWeight: 700, cursor: 'pointer' }}>
                        Faire une demande (enquête)
                    </button>
                ) : (
                    <form onSubmit={submit} style={{ display: 'grid', gap: 10 }}>
                        <input required style={field} placeholder="Service ou organisme (ex. commissariat, gendarmerie, cabinet)" value={form.organization} onChange={set('organization')} maxLength={200} />
                        <input style={field} placeholder="Référence de procédure (facultatif)" value={form.reference} onChange={set('reference')} maxLength={200} />
                        <input required style={field} placeholder="Nom et prénom" value={form.name} onChange={set('name')} maxLength={200} />
                        <input required type="email" style={field} placeholder="Adresse e-mail professionnelle" value={form.email} onChange={set('email')} maxLength={254} />
                        <input required type="tel" style={field} placeholder="Téléphone" value={form.phone} onChange={set('phone')} maxLength={40} />
                        <textarea required minLength={10} rows={4} style={field} placeholder="Motif de la demande" value={form.reason} onChange={set('reason')} maxLength={2000} />
                        <p style={{ margin: 0, fontSize: '0.8rem', color: '#A0A0A0' }}>
                            Ces informations servent uniquement à vérifier et traiter la demande. Toute demande est enregistrée.
                        </p>
                        <button type="submit" disabled={state.sending}
                            style={{ padding: 12, borderRadius: 10, border: 0, background: '#FACC15', color: '#0A192F', fontWeight: 700, cursor: 'pointer' }}>
                            {state.sending ? 'Envoi…' : 'Envoyer la demande'}
                        </button>
                        {state.error && <p role="alert" style={{ margin: 0, color: '#fca5a5' }}>{state.error}</p>}
                    </form>
                )}
            </section>
        </main>
    );
}
